module.exports = __webpack_public_path__ + "static/img/circel_01.3254740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/circel_01.png
// module id = 8EDY
// module chunks = 1